import { WorkbenchProvider } from '@gusto/workbench';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import NoMatch from 'helpers/no_match';
import { PartnerSignupProvider } from './components/partnersSignupProvider';
import Layout from './components/layout';
import PartnerSurvey from './components/partner_survey';
import PartnerForm from './components/partner_form';

export default function App({
  domains,
  isTofuSurveyExperimentEnabled,
}: {
  domains: string[];
  isTofuSurveyExperimentEnabled: boolean;
}) {
  return (
    <BrowserRouter basename="/partners/signup">
      <WorkbenchProvider>
        <PartnerSignupProvider>
          <Routes>
            <Route
              path="/"
              element={<Layout isTofuSurveyExperimentEnabled={isTofuSurveyExperimentEnabled} />}
            >
              <Route index element={<PartnerSurvey />} />
              <Route path="/form" element={<PartnerForm ssoDomains={domains} />} />
              <Route path="*" element={<NoMatch packageName="PartnerSignup" />} />
            </Route>
          </Routes>
        </PartnerSignupProvider>
      </WorkbenchProvider>
    </BrowserRouter>
  );
}
